<template>
  <li class="frisbuy-gallery-post pn-ad-post">
    <div class="frisbuy-post-image" @click="showPopup = true">
      <img :src="`${envDomain}/images/urbanvibes-ad.png`" alt="Urbanvibes" />
    </div>
    <div
      class="frisbuy-popup-overlay"
      @click="showPopup = false"
      v-if="showPopup"
    >
      <div
        :class="{ 'frisbuy-popup': true, 'frisbuy-scroller': true }"
        @click.stop
        ref="iuPopup"
      >
        <div class="frisbuy-popup-controls">
          <div class="frisbuy-popup-navigation">
            <div
              class="frisbuy-popup-control frisbuy-prev"
              @click="openPost(1)"
            >
              <svg viewBox="0 0 24 43">
                <path d="M21,0.976190476 L0.923190379,20.5749808" id="Line"></path>
                <path d="M21,20.5 L0.923190379,40.0987903" id="Line" transform="translate(11.000000, 30.261905) scale(1, -1) translate(-11.000000, -30.261905) "></path>
              </svg>
            </div>
            <div
              class="frisbuy-popup-control frisbuy-next"
              @click="openPost(3)"
            >
              <svg viewBox="0 0 24 43">
                <path d="M21,0.976190476 L0.923190379,20.5749808" id="Line"></path>
                <path d="M21,20.5 L0.923190379,40.0987903" id="Line" transform="translate(11.000000, 30.261905) scale(1, -1) translate(-11.000000, -30.261905) "></path>
              </svg>
            </div>
          </div>
          <div
            class="frisbuy-popup-control frisbuy-close"
            @click="showPopup = false"
          >
            <svg viewBox="0 0 26 26">
              <path d="M22.8863702,1.11362984 L0.52753736,23.4724626" id="Line" transform="translate(12.000000, 12.000000) scale(1, -1) translate(-12.000000, -12.000000) "></path>
              <path d="M22.8863702,1.11362984 L0.52753736,23.4724626" id="Line" transform="translate(12.000000, 12.000000) scale(-1, -1) translate(-12.000000, -12.000000) "></path>
            </svg>
          </div>
        </div>
        <div
          class="frisbuy-content-wrapper frisbuy-scroller"
          ref="scrollWrapper"
        >
          <div class="frisbuy-popup-content">
            <div class="frisbuy-popup-media">
              <img :src="`${envDomain}/images/urbanvibes-ad.png`" alt="Urbanvibes" />
            </div>
          </div>
          <div class="frisbuy-popup-details">
            <div
              class="frisbuy-details-scroller frisbuy-scroller"
              ref="scrollDetails"
            >
              <div class="pn-ad-title">ДЕЛИСЬ СТИЛЕМ</div>
              <div class="pn-ad-description">
                Выкладывай свои образы в соцсетях, отмечай urban vibes или загружай свой аутфит прямо на сайте.
              </div>

              <div widget-iu-button="true" onclick="iuWidget.open()" class="frb-upload-button-all">
                <div class="photo-conteiner">
                  <div class="photo"></div>
                </div>
                <div class="frb-upload-button-text">
                  Добавь свой аутфит
                </div>            	      	
              </div>

              <div class="pn-ad-divider"></div>
              <div class="pn-ad-hint">
                Все фото проходят модерацию, загружая фотографии, ты
                подтверждаешь согласие с нашими
                <a target="_blank" href="https://urbanvibes.com/privacy/"
                  >правилами обработки персональных данных</a
                >.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
const bodyScrollLock = require('body-scroll-lock');

export default {
  data() {
    return {
      showPopup: false
    };
  },

  props: ['settings'],

  methods: {
    openPost(index) {
      this.showPopup = false;
      this.$emit('open-post', index);
    }
  },

  watch: {
    showPopup(value) {
      this.$nextTick(() => {
        const { scrollWrapper } = this.$refs;

        if (value) {
          this.sendAnaliticEvent('Click_ad_post', window.location.href);
          bodyScrollLock.disableBodyScroll(scrollWrapper);
        } else {
          bodyScrollLock.clearAllBodyScrollLocks();
        }
      });
    }
  }
};
</script>

<style lang="scss">
.frisbuy-gallery-post.pn-ad-post {
  cursor: pointer;
  color: #2c2c2c;
  position: relative;
  flex-shrink: 0;

  .frisbuy-post-image {
    width: 100%;
    padding-bottom: 100%;

    & > img {
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }
  }

  .pn-ad-title {
    font-weight: bold;
    font-size: 24px;
    line-height: 34px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    margin-top: 25px;
  }

  .pn-ad-description {
    font-size: 14px;
    line-height: 19px;
    margin: 24px 0;
  }

  .pn-ad-upload-button {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    text-transform: uppercase;
    margin-top: 40px;
    cursor: pointer;
  }

  .pn-ad-tag-text {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    text-transform: uppercase;
    margin-top: 16px;
    border-bottom: 1px solid #c0c0c0;
  }

  .pn-ad-divider {
    flex-grow: 1;
  }

  .pn-ad-hint {
    font-size: 12px;
    line-height: 18px;
  }

  .frisbuy-popup-media {
    width: 531px;

    & > img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .frisbuy-details-scroller {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    a {
      text-decoration: none;
      color: inherit;
      border-bottom: 1px solid #c0c0c0;
    }
  }

  .frisbuy-popup .frisbuy-popup-details {
    padding-left: 24px;
  }

  .frisbuy-popup-details:after {
    display: none;
  }

  .frisbuy-popup-overlay {
    cursor: default;
  }

  .frisbuy-popup {
    padding: 51px;
  }

  .le-hash-copied {
    padding: 10px 61px;
    position: absolute;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    text-transform: uppercase;
    color: #2c2c2c;
    background: #ffffff;
    border: 1px solid #c0c0c0;
    border-radius: 56px;
    bottom: 10px;
    left: calc(50% - 141px);

    &.le-hash-enter-active {
      opacity: 0;
      transition: opacity 1s;
    }

    &.le-hash-enter-to {
      opacity: 1;
    }

    &.le-hash-leave-active {
      opacity: 1;
      transition: 1s opacity 3s;
    }

    &.le-hash-leave-to {
      opacity: 0;
    }
  }

  @media only screen and (max-width: 1199px) {
    .frisbuy-popup {
      padding: 10px;
    }

    .frisbuy-popup-media {
      width: 441px;
    }
  }

  @media only screen and (max-width: 767px) {
    .frisbuy-popup {
      padding: 0;
    }

    .frisbuy-popup-media {
      width: 100%;

      svg {
        position: absolute;
      }
    }

    .frisbuy-popup-details {
      padding: 0 30px;
    }

    .frisbuy-popup-controls {
      justify-content: flex-end !important;
    }

    .le-hash-copied {
      position: fixed;
    }
  }
}
</style>
